import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["item", "view", "className"];
import React, { useMemo } from 'react';
import { Icon, Label, UserAvatar } from '@gravity-ui/uikit';
import { escapeHighlight, filterMatches, getUserAvatarLink } from '../../utils';
import { block } from '../../utils/cn';
import { Highlight } from '../Highlight/Highlight';
import { DescDelimiter } from './DescDelimiter';
import { Row } from './Row';
import i18n from './i18n';
import telegramIcon from '../../assets/icons/telegram';
import './StaffRow.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var b = block('search-staff-row');
export function StaffRow(_ref) {
  var _item$name, _item$name2, _item$name3, _item$name4, _item$name5, _item$name6, _item$name7;
  var item = _ref.item,
    view = _ref.view,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var isMobileView = view === 'mobile';
  var avatar = /*#__PURE__*/_jsx(UserAvatar, {
    imgUrl: getUserAvatarLink(escapeHighlight(item.login), isMobileView ? 24 : 32),
    size: isMobileView ? 'xs' : 'm'
  });
  var matchedTelegrams = useMemo(function () {
    return filterMatches(item.telegram);
  }, [item.telegram]);
  var telegram = matchedTelegrams === null || matchedTelegrams === void 0 ? void 0 : matchedTelegrams[0];
  var title = /*#__PURE__*/_jsxs(_Fragment, {
    children: [!item.is_dismissed || item.staff_agreement ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs("span", {
        className: b('person-name'),
        title: "".concat(escapeHighlight((_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.first), " ").concat(escapeHighlight((_item$name2 = item.name) === null || _item$name2 === void 0 ? void 0 : _item$name2.last)),
        children: [/*#__PURE__*/_jsx(Highlight, {
          text: (_item$name3 = item.name) === null || _item$name3 === void 0 ? void 0 : _item$name3.first
        }), (_item$name4 = item.name) !== null && _item$name4 !== void 0 && _item$name4.last ? /*#__PURE__*/_jsx(_Fragment, {
          children: "\xA0"
        }) : null, /*#__PURE__*/_jsx(Highlight, {
          text: (_item$name5 = item.name) === null || _item$name5 === void 0 ? void 0 : _item$name5.last
        })]
      }), (_item$name6 = item.name) !== null && _item$name6 !== void 0 && _item$name6.first || (_item$name7 = item.name) !== null && _item$name7 !== void 0 && _item$name7.last ? /*#__PURE__*/_jsx(_Fragment, {
        children: ",\xA0"
      }) : null]
    }) : null, /*#__PURE__*/_jsx("span", {
      className: b('login'),
      children: /*#__PURE__*/_jsx(Highlight, {
        text: "".concat(item.login, "@")
      })
    }), telegram ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(DescDelimiter, {}), /*#__PURE__*/_jsxs("span", {
        className: b('telegram'),
        title: escapeHighlight(telegram),
        children: [/*#__PURE__*/_jsx(Icon, {
          data: telegramIcon,
          className: b('telegram-icon'),
          size: 14
        }), /*#__PURE__*/_jsx(Highlight, {
          text: telegram
        })]
      })]
    }) : null]
  });
  var description = /*#__PURE__*/_jsxs(_Fragment, {
    children: [item.is_dismissed ? /*#__PURE__*/_jsx(Label, {
      theme: "unknown",
      className: b('former'),
      children: i18n('context_dismissed')
    }) : null, /*#__PURE__*/_jsx(Highlight, {
      text: item.department_name
    })]
  });
  return /*#__PURE__*/_jsx(Row, _objectSpread({
    logo: avatar,
    title: title,
    description: description,
    item: item,
    view: view,
    className: b({
      dismissed: item.is_dismissed
    }, className)
  }, otherProps));
}
// #sourceMappingURL=StaffRow.js.map